import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


function mapModule() {
    const mapElement = document.getElementById('map');

    if (!mapElement) {
        return;
    }

    const latMercedes = mapElement.getAttribute('data-mercedes-lat');
    const longMercedes = mapElement.getAttribute('data-mercedes-long');
    const iconMercedes = mapElement.getAttribute('data-mercedes-icon');
    let markersSelected = {};

    const parseAttribute = (attrName) => {
        const rawValue = mapElement.getAttribute(attrName);

        if (!rawValue) {
            return [];
        }

        try {
            const parsedValue = JSON.parse(rawValue);

            return Array.isArray(parsedValue) ? parsedValue : [];
        } catch (error) {
            console.warn(`mapModule: failed to parse ${attrName}`, error);

            return [];
        }
    };

    const markers = parseAttribute('data-markers');

    ///////////////////////////////////////////////////////

    // console.log('markers', markers);
    // console.log('markers', iconMercedes);

    ///////////////////////////////////////////////////////

    const key = 'Y1Qo9MpsdhgTIxFbCjua';
    const map = L.map('map').setView([parseFloat(markers[0].center.lat), parseFloat(markers[0].center.longitude)], parseInt(markers[0].zoom));

    // Estilo vectorial personalizado (equivalente al estilo de Snazzy Maps).
    // Usa los tiles vectoriales de MapTiler para poder re-colorear en el cliente.
    const mapStyle = {
        version: 8,
        glyphs: `https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=${key}`,
        sources: {
            openmaptiles: {
                type: 'vector',
                url: `https://api.maptiler.com/tiles/v3/tiles.json?key=${key}`
            }
        },
        layers: [
            {
                id: 'background',
                type: 'background',
                paint: { 'background-color': '#e0efef' }
            },
            {
                id: 'landcover-green',
                type: 'fill',
                source: 'openmaptiles',
                'source-layer': 'landcover',
                filter: ['in', 'class', 'wood', 'grass', 'scrub'],
                paint: { 'fill-color': '#c0e8e8' }
            },
            {
                id: 'landuse-green',
                type: 'fill',
                source: 'openmaptiles',
                'source-layer': 'landuse',
                filter: ['in', 'class', 'park', 'cemetery', 'recreation_ground', 'golf_course'],
                paint: { 'fill-color': '#c0e8e8' }
            },
            {
                id: 'water',
                type: 'fill',
                source: 'openmaptiles',
                'source-layer': 'water',
                paint: { 'fill-color': '#7dcdcd' }
            },
            {
                id: 'waterway',
                type: 'line',
                source: 'openmaptiles',
                'source-layer': 'waterway',
                paint: { 'line-color': '#7dcdcd', 'line-width': 1 }
            },
            {
                id: 'roads',
                type: 'line',
                source: 'openmaptiles',
                'source-layer': 'transportation',
                filter: ['!in', 'class', 'rail', 'transit', 'ferry'],
                paint: {
                    'line-color': '#ffffff',
                    'line-width': ['interpolate', ['linear'], ['zoom'], 6, 0.5, 12, 1.5, 16, 4]
                }
            },
            {
                id: 'transit-lines',
                type: 'line',
                source: 'openmaptiles',
                'source-layer': 'transportation',
                filter: ['in', 'class', 'rail', 'transit'],
                paint: {
                    'line-color': '#9bc3c3',
                    'line-width': ['interpolate', ['linear'], ['zoom'], 10, 0.6, 14, 1.2, 18, 2.4],
                    'line-dasharray': [3, 2]
                }
            },
            {
                id: 'street-labels',
                type: 'symbol',
                source: 'openmaptiles',
                'source-layer': 'transportation_name',
                minzoom: 15,
                layout: {
                    'symbol-placement': 'line',
                    'text-field': ['coalesce', ['get', 'name:es'], ['get', 'name']],
                    'text-font': ['Open Sans Regular'],
                    'text-size': ['interpolate', ['linear'], ['zoom'], 15, 9, 18, 12],
                    'text-max-angle': 30,
                    'text-padding': 2
                },
                paint: {
                    'text-color': '#6a7f7f',
                    'text-halo-color': '#ffffff',
                    'text-halo-width': 1.2
                }
            },
            {
                id: 'place-labels',
                type: 'symbol',
                source: 'openmaptiles',
                'source-layer': 'place',
                filter: ['in', 'class', 'city', 'town', 'village', 'suburb', 'neighbourhood', 'hamlet'],
                layout: {
                    'text-field': ['coalesce', ['get', 'name:es'], ['get', 'name']],
                    'text-font': ['Open Sans Regular'],
                    'text-size': ['interpolate', ['linear'], ['zoom'], 6, 11, 12, 14, 16, 18],
                    'text-anchor': 'top',
                    'text-offset': [0, 0.4],
                    'text-max-width': 8
                },
                paint: {
                    'text-color': '#4a6b6b',
                    'text-halo-color': '#e0efef',
                    'text-halo-width': 1.5
                }
            },
            {
                id: 'park-labels',
                type: 'symbol',
                source: 'openmaptiles',
                'source-layer': 'park',
                minzoom: 12,
                layout: {
                    'text-field': ['coalesce', ['get', 'name:es'], ['get', 'name']],
                    'text-font': ['Open Sans Italic'],
                    'text-size': ['interpolate', ['linear'], ['zoom'], 12, 10, 16, 13],
                    'text-max-width': 8
                },
                paint: {
                    'text-color': '#5a8a6a',
                    'text-halo-color': '#e0efef',
                    'text-halo-width': 1.2
                }
            },
            {
                id: 'transit-stations',
                type: 'circle',
                source: 'openmaptiles',
                'source-layer': 'poi',
                minzoom: 13,
                filter: ['in', 'class', 'bus', 'railway'],
                paint: {
                    'circle-radius': ['interpolate', ['linear'], ['zoom'], 13, 2, 17, 4],
                    'circle-color': '#4a6b6b',
                    'circle-stroke-color': '#ffffff',
                    'circle-stroke-width': 1
                }
            },
            {
                id: 'transit-station-labels',
                type: 'symbol',
                source: 'openmaptiles',
                'source-layer': 'poi',
                minzoom: 14,
                filter: ['in', 'class', 'bus', 'railway'],
                layout: {
                    'text-field': ['coalesce', ['get', 'name:es'], ['get', 'name']],
                    'text-font': ['Open Sans Regular'],
                    'text-size': 11,
                    'text-anchor': 'left',
                    'text-offset': [0.6, 0],
                    'text-max-width': 8
                },
                paint: {
                    'text-color': '#4a6b6b',
                    'text-halo-color': '#e0efef',
                    'text-halo-width': 1.2
                }
            },
            {
                id: 'poi-dots',
                type: 'circle',
                source: 'openmaptiles',
                'source-layer': 'poi',
                minzoom: 14,
                filter: ['all', ['<=', 'rank', 4], ['!in', 'class', 'bus', 'railway']],
                paint: {
                    'circle-radius': ['interpolate', ['linear'], ['zoom'], 14, 1.5, 18, 3.5],
                    'circle-color': '#7a9a9a',
                    'circle-stroke-color': '#ffffff',
                    'circle-stroke-width': 1
                }
            },
            {
                id: 'poi-labels',
                type: 'symbol',
                source: 'openmaptiles',
                'source-layer': 'poi',
                minzoom: 15,
                filter: ['all', ['<=', 'rank', 4], ['!in', 'class', 'bus', 'railway']],
                layout: {
                    'text-field': ['coalesce', ['get', 'name:es'], ['get', 'name']],
                    'text-font': ['Open Sans Regular'],
                    'text-size': 11,
                    'text-anchor': 'top',
                    'text-offset': [0, 0.5],
                    'text-max-width': 8
                },
                paint: {
                    'text-color': '#6a7f7f',
                    'text-halo-color': '#e0efef',
                    'text-halo-width': 1.2
                }
            }
        ]
    };

    L.maplibreGL({ style: mapStyle }).addTo(map);

    ///////////////////////////////////////////////////////

    // Layer group to manage dynamic markers
    let markerGroup = L.layerGroup().addTo(map);

    const mainMarker = L.icon({
        iconUrl: iconMercedes,
        iconSize: [91, 97],
    });

    L.marker([parseFloat(latMercedes), parseFloat(longMercedes)], { icon: mainMarker }).addTo(map);

    markers[0].locations.forEach(marker => {
        // console.log('marker', marker);

        const dotMarker = L.icon({
            iconUrl: themeData.templateUrl + '/dist/images/marker-general.png',
            iconSize: [24, 24],
        });

        // Add markers to the group instead of directly to map
        L.marker([parseFloat(marker.lat), parseFloat(marker.long)], { icon: dotMarker }).addTo(markerGroup);

    });

    ///////////////////////////////////////////////////////

    const markerContainer = document.querySelector('.markersGroups');
    const groupItems = Array.from(document.querySelectorAll('.markersGroup')).map(group => {
        const footer = group.querySelector('.markersGroup__footer');
        const toggleBtn = group.querySelector('.markersGroup__btn--toggle');
        const toggleSelect = group.querySelector('.markersGroup__btn--select');
        const symbol = toggleSelect ? toggleSelect.querySelector('span') : null;

        if (footer) {
            gsap.set(footer, { height: 0, autoAlpha: 0, display: 'none' });
        }

        return {
            group,
            footer,
            toggleBtn,
            toggleSelect,
            symbol
        };
    }).filter(item => item.footer && item.toggleBtn && item.toggleSelect && item.symbol);

    let activeGroup = null;

    const getDistanceValue = (locationEl, mode) => {
        const modeDistances = {
            walk: locationEl.dataset.distanceWalk || '',
            bike: locationEl.dataset.distanceBike || '',
            car: locationEl.dataset.distanceCar || ''
        };

        return modeDistances[mode] || modeDistances.walk || modeDistances.bike || modeDistances.car || '';
    };

    const setupDistanceModes = (group) => {
        const transportSection = group.querySelector('.markersGroup__transport');

        if (!transportSection) {
            return;
        }

        const modeButtons = Array.from(transportSection.querySelectorAll('.markersGroup__transport-btn'));
        const locations = Array.from(group.querySelectorAll('.markersGroup__location'));
        const initialMode = transportSection.dataset.initialMode || 'walk';

        const applyMode = (mode) => {
            modeButtons.forEach(button => {
                const isActive = button.dataset.mode === mode;

                button.classList.toggle('is-active', isActive);
                button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });

            locations.forEach(locationEl => {
                const valueEl = locationEl.querySelector('.markersGroup__location__value');

                if (!valueEl) {
                    return;
                }

                valueEl.textContent = getDistanceValue(locationEl, mode);
            });
        };

        modeButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                applyMode(button.dataset.mode || 'walk');
            });
        });

        applyMode(initialMode);
    };

    groupItems.forEach(item => {
        setupDistanceModes(item.group);
    });

    const updateMarkersForGroup = (index) => {
        markersSelected = markers[index];

        if (!markersSelected) {
            return;
        }

        const lat = parseFloat(markersSelected.center.lat);
        const long = parseFloat(markersSelected.center.longitude);
        const zoom = parseInt(markersSelected.zoom);

        map.setView([lat, long], zoom, {
            animate: true,
            duration: 1.0
        });

        markerGroup.clearLayers();

        markersSelected.locations.forEach(marker => {
            const dotMarker = L.icon({
                iconUrl: themeData.templateUrl + '/dist/images/marker-general.png',
                iconSize: [24, 24],
            });

            L.marker([parseFloat(marker.lat), parseFloat(marker.long)], { icon: dotMarker }).addTo(markerGroup);
        });
    };

    const openGroup = (item, index) => {
        if (!item.footer) {
            return;
        }

        item.group.classList.add('is-open');
        activeGroup = item;

        const expandTimeline = gsap.timeline({
            onComplete: () => {
                item.group.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                ScrollTrigger.refresh();
            }
        });

        expandTimeline
            .set(item.footer, { display: 'block', height: 0 })
            .to(item.footer, {
                height: 'auto',
                duration: 0.4,
                ease: 'power2.out'
            })
            .to(item.footer, {
                autoAlpha: 1,
                duration: 0.2,
                ease: 'power2.out'
            }, '<');

        gsap.to(item.symbol, {
            autoAlpha: 0,
            duration: 0.15,
            onComplete: () => {
                item.symbol.textContent = '-';
                item.symbol.style.marginTop = '-4px';
                gsap.to(item.symbol, { autoAlpha: 1, duration: 0.15 });
            }
        });

        updateMarkersForGroup(index);
    };

    const closeGroup = (item) => {
        if (!item || !item.footer || !item.group.classList.contains('is-open')) {
            return;
        }

        item.group.classList.remove('is-open');

        gsap.timeline({
            onComplete: () => {
                ScrollTrigger.refresh();
            }
        })
            .to(item.footer, {
                height: 0,
                duration: 0.3,
                ease: 'power2.in'
            })
            .to(item.footer, {
                autoAlpha: 0,
                duration: 0.2,
                ease: 'power2.in'
            }, '<')
            .set(item.footer, { display: 'none' });

        gsap.to(item.symbol, {
            autoAlpha: 0,
            duration: 0.15,
            onComplete: () => {
                item.symbol.style.marginTop = '0';
                item.symbol.textContent = '+';
                gsap.to(item.symbol, { autoAlpha: 1, duration: 0.15 });
            }
        });

        if (activeGroup === item) {
            activeGroup = null;
        }
    };

    groupItems.forEach((item, index) => {
        console.log('item', item);

        item.group.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (item.group.classList.contains('is-open')) {
                closeGroup(item);
                return;
            }

            if (activeGroup && activeGroup !== item) {
                closeGroup(activeGroup);
            }

            openGroup(item, index);
        });
    });

    if (markerContainer) {
        const syncMarkerHeight = () => {
            // Keep the markers list constrained to the map height.
            markerContainer.style.maxHeight = `${mapElement.offsetHeight}px`;
        };

        syncMarkerHeight();
        window.addEventListener('resize', syncMarkerHeight);
    }

    ///////////////////////////////////////////////////////




    // const extraMarker = L.icon({
    //     iconUrl: themeData.iconPath2,
    //     iconSize: [25, 25],
    // });

    // if (Array.isArray(markers)) {
    //     markers.forEach(marker => {
    //         L.marker([parseFloat(marker.coord.lat), parseFloat(marker.coord.long)], { icon: dotMarker })
    //             .bindTooltip(marker.texto || "Location", {
    //                 permanent: false,
    //                 direction: 'bottom',
    //                 offset: [0, 3],
    //                 className: 'map__marker-label'
    //             })
    //             .addTo(map);
    //     });
    // }


}

export default mapModule;